import { useCallback } from 'react';

import type {
	LWApiPublicBillingStripePaymentDetailsParamsRaw,
	LWApiPublicBillingStripePaymentIntentResultRaw,
} from '@liquidweb-dev/club-sauce/public/billing/stripe/payment/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';

export const BILLING_STRIPE_PAYMENT_DETAILS_QUERY_KEY =
	'/billing/stripe/payment/details';

/** Reads a PaymentIntent's current state on demand, bypassing the cache. */
const useFetchBillingStripePaymentDetails = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(params: LWApiPublicBillingStripePaymentDetailsParamsRaw) =>
			queryClient.fetchQuery<
				LWApiPublicBillingStripePaymentIntentResultRaw,
				ApiErrorI
			>({
				queryKey: [BILLING_STRIPE_PAYMENT_DETAILS_QUERY_KEY, params],
				queryFn: () => api.billing.stripe.payment.apiRaw.details(params),
				staleTime: 0,
			}),
		[queryClient],
	);
};

export default useFetchBillingStripePaymentDetails;
